import React from "react";

interface Topic {
  topic_name: string;
}

interface TopicSelectorProps {
  topics: Topic[];
  selectedTopic: string | null;
  handleTopicSelect: (topic: string | null) => void;
}

const TopicSelector: React.FC<TopicSelectorProps> = ({ topics, selectedTopic, handleTopicSelect }) => {
  return (
    <div className="flex flex-row gap-8 border-b-2 border-[#F3F4F6] pb-0">
      {topics.map((topic) => (
        <div
          key={topic.topic_name}
          className={`text-base font-semibold cursor-pointer px-4 py-3 relative transition-all duration-300 ease-in-out hover:text-primary ${selectedTopic === topic.topic_name
            ? "text-[#5A46A7] after:content-[''] after:absolute after:bottom-[-2px] after:left-0 after:w-full after:h-[2px] after:bg-primary"
            : "text-[#64748B]"
            }`}
          onClick={() => handleTopicSelect(topic.topic_name)}
        >
          {topic.topic_name}
        </div>
      ))}
    </div>
  );
};

export default TopicSelector;
